import { memo } from 'react';
import AccordionPerson from 'shell/components/shared/person';

interface RegistryOfficeAccordionProps {
  expanded: boolean;
  toggle: () => void;
}

const RegistryOfficeAccordionComponent = ({}: RegistryOfficeAccordionProps): React.ReactElement => {
  return <AccordionPerson disabled />;
};

RegistryOfficeAccordionComponent.displayName = 'Accordion person';

const RegistryOfficeAccordion = memo(RegistryOfficeAccordionComponent);

export default RegistryOfficeAccordion;
